import { useEffect, useSyncExternalStore } from 'react';

const APP = 'Darsly CRM';

// The name of the record the open page shows ("Jane Karimova", "Test Corp"), with the path it was
// published for. The top bar reads it for the last breadcrumb of a nested route, so a stale name
// never shows on another page: it only counts while the path still matches.
let entry = { path: null, label: '' };
const listeners = new Set();

function publish(next) {
  entry = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function currentPath() {
  return typeof window === 'undefined' ? '' : window.location.pathname;
}

/**
 * Names the page: the browser tab reads "Jane Karimova · Darsly CRM" and the top-bar breadcrumb
 * ends in "Jane Karimova" instead of the generic "O'quvchi tafsiloti". Pass the translated generic
 * title while the record loads and its own name once it is in. The previous tab title comes back
 * when the page goes away.
 */
export function usePageTitle(label) {
  const path = currentPath();
  useEffect(() => {
    if (!label) return undefined;
    const before = document.title;
    document.title = `${label} · ${APP}`;
    const mine = { path, label };
    publish(mine);
    return () => {
      document.title = before;
      if (entry === mine) publish({ path: null, label: '' });
    };
  }, [label, path]);
}

/** The name the page at `pathname` published, or '' when it has not named itself. */
export function usePageLabel(pathname) {
  return useSyncExternalStore(
    subscribe,
    () => (entry.path === pathname ? entry.label : ''),
    () => '',
  );
}

export default usePageTitle;
